import { observer } from 'mobx-react';
import * as React from 'react';
import { equalArrays, includes } from '../../../../../../../../Collections';
import { T } from '../../../../../../../../Translations';
import FilterStore from '../Store';
import { FilterOptions } from '../Types';

interface Props {
  option: FilterOptions;
  filterStore: FilterStore;
}

const checkboxCondition = (option: FilterOptions, filterStore: FilterStore) => {
  switch (option.kind) {
    case 'all-options':
    case 'all-hours':
      return equalArrays(filterStore.state.filter.options, filterStore.initialFilterValues.options);
    case 'some-options':
    case 'some-hours':
    case 'no-hour':
      return includes(option.value, filterStore.state.filter.options);
    case 'no-option':
      return false;
  }
};

const optionLabel = (option: FilterOptions) => {
  switch (option.kind) {
    case 'all-options':
    case 'all-hours':
    case 'some-options':
    case 'no-option':
      return <>{option.label}</>;
    case 'some-hours':
      return <T kind="{{count}} hour" count={Number(option.value)} />;
    case 'no-hour':
      return <T kind="Flexible" />;
  }
};

const DropdownItem: React.FC<Props> = ({ option, filterStore }) => (
  <button onClick={() => filterStore.filterAllValues(option)} className="flex w-full py-1">
    <div className="m-1 flex w-full flex-row justify-between bg-white text-gray-700">
      <div className="flex flex-row pr-6">
        <div className="pr-2">
          <div className="flex h-6 items-center">
            <input
              id="filters"
              aria-describedby="filters-description"
              name="filters"
              type="checkbox"
              checked={checkboxCondition(option, filterStore)}
              className="h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-600"
            />
          </div>
        </div>
        <div className="text-sm whitespace-nowrap">{optionLabel(option)}</div>
      </div>
      <div className="mr-3 text-sm">{option.count}</div>
    </div>
  </button>
);

export default observer(DropdownItem);
